import { useProductsQuery } from '@/services/products'
import { Box, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { columns } from './columns'
import DataGridTable from '@/components/shared/DataGridTable'
import { useDataGridConfig, filterRows } from '@/hooks/useDataGridConfig'

export default function ProductsPage() {
  const navigate = useNavigate()
  const { products, isLoading, isFetching } = useProductsQuery()
  const config = useDataGridConfig({ tableId: 'products', syncToUrl: true })

  const filteredProducts = filterRows(products, config.filters)

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Typography variant='pageTitle' component='h1' sx={{ fontSize: '24px' }}>
        Products
      </Typography>

      <DataGridTable
        {...config}
        filterMode='client'
        rows={filteredProducts}
        columns={columns}
        loading={isLoading || isFetching}
        getRowId={row => row.hash}
        onRowClick={params =>
          navigate(`/products/${params.row.hash}`, {
            state: { backLabel: 'Back to Products', fallbackPath: '/products' }
          })
        }
      />
    </Box>
  )
}
